<template>
  <div>
    <!--div id="modal-wa-dialog" uk-modal>
<div class="uk-modal-dialog uk-modal-body">
<button class="uk-modal-close-default" type="button" uk-close></button>
<h2>¡Escribenos por WhatsApp!</h2>
<p>
Contamos con dos numeros para brindarte una mejor atención, por favor
da click o toca una de las siguientes opciones
</p>
<p class="uk-margin-remove uk-text-lead">
  <a href="https://wa.me/message/5561800539"><i class="fab fa-whatsapp"></i>55 6180 0539</a>
</p>
<p class="uk-margin-remove uk-text-lead">
<a href="https://wa.me/message/6QAF4MZE26NDD1" ><i class="fab fa-whatsapp"></i> 55 4895 2507</a>
</p>
</div>
</div-->

    <div class="wa-content">
      <a href="https://wa.me/5561800539?text=Hola%20me%20interesa" target="_blank">
        <img src="https://www.centrodetanatologia.com/images/wa_logo.png" />
      </a>
    </div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col-md-2">
            <router-link to="/"><img class="img-fluid logo" src="@/assets/images/logo.png" /></router-link>
          </div>
          <div class="col-md-6">
            <p style="font-size: 22px; color: #2a2b58 !important" class="mt-5 font-weight-bold">
              CENTRO DE TANATOLOGÍA Y TERAPIA DE DUELO
            </p>
            <p style="font-size: 18px;color: #2a2b58;font-weight: bolder;">Educación continua de IMPo e IMESP &nbsp;
                <a href="https://www.impo.org.mx/" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/images/logos/logo_impo_azul.png" alt="Logo IMPo" width="40px" /></a>
                <a href="https://www.estudiosdeposgrado.org.mx/" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/images/logos/logo_imesp_azul.png" alt="Logo IMESP" width="40px" /></a>
            </p>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 text-right">
                <span class="align-middle">INFORMES: </span>
              </div>
              <div class="col-sm-8">
                <div class="text-right">
                  <span style="color: #37407d">Plantel Montevideo: </span><span class="text-danger font-weight-bold"
                    style="font-size: 16px">55 6393-1100</span><br />
                  <span style="color: #37407d">Plantel Tláhuac: </span><span class="text-danger font-weight-bold"
                    style="font-size: 16px">55 6819-2000</span><br />
                  <span style="color: #37407d">Plantel Tlalpan: </span><span class="text-danger font-weight-bold"
                    style="font-size: 16px">55 6393-2000</span><br />
                </div>
              </div>
            </div>
            <div class="text-right mt-3">
              <a href="https://www.tiktok.com/@impooficialmexico" target="_blank">
                <img src="https://impo.org.mx/images/logo_tiktok.png"
                  style="width:30px; margin:-8px 0 8px 5px; padding:0;">
              </a>
              <a href="https://www.instagram.com/impooficial/" target="_blank"><i class="fab fa-instagram ml-2"
                style="font-size: 30px; color: #3b5998"></i></a>
              <a href="https://radioimpo.com.mx/" target="_blank"><span style="font-size: 10px; margin-left: 20px">RADIO
                  IMPo</span><i class="fa fa-microphone ml-2" aria-hidden="true"
                  style="font-size: 25px; color: #3b5998; margin-left: 5px"></i></a>
              <a href="https://twitter.com/IMPo_Oficial" target="_blank">
                <img src="https://www.centrodetanatologia.com/images/logo_x.webp"
                  style="width:30px; margin:-8px 0 8px 5px; padding:0;">
              </a>
              <a href="https://www.youtube.com/channel/UCCmxYMZSLn7QGoyo1qFPl9A" target="_blank"><i
                  class="fab fa-youtube-square ml-2" style="font-size: 30px; color: #ff0000"></i></a>
              <a href="https://www.facebook.com/profile.php?id=100063598561547" target="_blank"><i class="fab fa-facebook-square ml-2"
                  style="font-size: 30px; color: #3b5998"></i></a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="menu-area">
      <nav class="navbar navbar-expand-lg navbar-dark">
        <button class="navbar-toggler d-lg-none" type="button" data-toggle="collapse" data-target="#navbarTogglerMainMenu"
          aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation" style="font-weight: bolder;color: rgba(255,255,255,.9);margin-right: auto;text-align: left;">
          <span class="navbar-toggler-icon" style="text-align: left;"></span>
          <!--span style="font-size: 11px;">Educación continua de IMPo e IMESP &nbsp;</span>
            <span style="margin-right: auto;text-align: center;"><a href="https://www.impo.org.mx/" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/images/logos/logo_impo_blanco.png" alt="Logo IMPo" width="25px"/></a>
            <a href="https://www.estudiosdeposgrado.org.mx/" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/images/logos/logo_imesp_blanco.png" alt="Logo IMESP" width="25px" /></a>
            </span-->
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerMainMenu">
          <ul class="container nav justify-content-end navbar-nav mr-auto mt-2 mt-lg-0" style="max-width:1500px;">
            <li class="nav-item d-none d-lg-block">
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/">Inicio</router-link>
            </li>
            <li class="nav-item dropdown">
              <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdownMenuLink" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Cursos
              </router-link>
              <div class="dropdown-menu drop-up ordenarmcursos" aria-labelledby="navbarDropdownMenuLink">
                <!--router-link class="dropdown-item" to="/herramientas-teo-meto-sociales">Paquete de herramientas teórico metodológicas</router-link-->
                <router-link to="curso-práctico-lengua-de-señas-mexicanas" class="dropdown-item">Lengua de señas mexicanas</router-link>
                <!-- <router-link to="herramientas-para-la-inclusión-social" class="dropdown-item">Herramientas para la inclusión social</router-link> -->
                <!-- <router-link to="desarrollo-de-habilidades-emocionales" class="dropdown-item">Desarrollo de habilidades
                  emocionales</router-link> -->
                <!--router-link class="dropdown-item" to="/examinación-del-estado-mental">Examinación del estado mental</router-link-->
                <router-link class="dropdown-item" to="/inteligencia-emocional-aplicada">Inteligencia Emocional Aplicada</router-link>
                <router-link class="dropdown-item" to="/intervencion-psicosocial-integrativa">Intervención Psicosocial Integrativa</router-link>
                <!--router-link class="dropdown-item" to="/glandula-pineal">Glándula Pineal</router-link-->
                <!--router-link class="dropdown-item" to="/primeros-auxilios-basicos">Primeros Auxilios Básicos</router-link-->
                <!--router-link class="dropdown-item" to="/tablas-excel-medio">Tablas de Excel Nivel Medio</router-link-->
                <!--router-link class="dropdown-item" to="/disena-impacta-chatgpt-canva">Diseña e Impacta con ChatGPT</router-link-->
                <!--router-link class="dropdown-item" to="/conexion-cuantico-psicoterapia">Conexión Mundo Cuántico y Psicoterapia Transpersonal</router-link-->
                <!--router-link class="dropdown-item" to="/sanando-heridas-transgeneracionales">Sanando Heridas Transgeneracionales</router-link-->
                <!--router-link class="dropdown-item" to="/resolviendo-duelos">Resolviendo mis Duelos</router-link-->
                <!--router-link class="dropdown-item" to="/amores-placeres-trascendencia">Amores, placeres y trascendencia</router-link-->
                <!--router-link class="dropdown-item" to="/formacion-cuidadores-domicilio">Formación de Cuidadores a Domicilio</router-link-->
                <!--router-link class="dropdown-item" to="/sociologia-suicidio">Sociología del Suicidio</router-link-->
                <!-- <router-link
class="dropdown-item"
to="/reporte-de-casos-clinicos"
>Reporte de casos clínicos</router-link
> -->
                <!--router-link class="dropdown-item" to="/expresión-en-público">Expresión en público</router-link-->
                <!--router-link class="dropdown-item" to="/propioAgenteSalud">Soy mi propio agente de salud</router-link-->
                <!-- <router-link class="dropdown-item text-wrap" to="/las-religiones-su-estudio-y-su-apoyo-terapéutico">Las religiones, su estudio y su apoyo terapéutico</router-link> -->
                <!-- <router-link
class="dropdown-item"
to="/lectura-comprensión-y-redacción-de-textos"
>Lectura, comprensión y redacción de textos</router-link
> -->
                <!--router-link class="dropdown-item" to="/psicofarmacologia-para-psicologos">Psicofarmacología</router-link-->
                <!-- <router-link
class="dropdown-item"
to="/el-proceso-penal-y-la-teoría-del-delito"
>El proceso penal y la teoría del delito</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/construyendo-el-debate"
>Construyendo el debate</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/desarrollo-humano-covid"
>Desarrollo humano ante COVID-19</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/curso-juicios-orales"
>Juicios Orales</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/herramientas-material-didactico"
>Herramientas para elaborar Material Didáctico
Digital</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/escenarios-aprendizaje-virtuales"
>Escenarios de Aprendizaje en Entornos Virtuales</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/aprendizaje-autogestivo"
>Aprendizaje Autogestivo</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/curso-terapia-de-pareja-y-sexualidad"
>Terapia de Pareja y Sexualidad</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/innovacion-de-las-rutinas-docentes"
>Innovacion de las rutinas docentes</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/aprendizaje-estrategico-y-tecnicas-de-estudio"
>Aprendizaje estratégico y técnicas de estudio</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/el-derecho-constitucional-como-principio-rector-de-las-reformas-del-estado-mexicano"
>La constitución como principio rector del estado
</router-link> -->
                <!-- <router-link
class="dropdown-item"
to="/adicciones-en-el-individuo-y-la-familia"
>Adicciones: en el individuo y la familia</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/curso-psicogenealogia"
>Psicogenealogía</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/el-poder-femenino-y-los-derechos">El Poder femenino y los derechos</router-link> -->
                <!--router-link class="dropdown-item" to="/trabajo-social-de-casos">Trabajo Social de casos</router-link-->
                <!-- <router-link
class="dropdown-item"
to="/curso-relaciones-humanas-y-trabajo-en-equipo"
>Relaciones humanas y trabajo en equipo</router-link
> -->
                <!--router-link class="dropdown-item" to="/curso-orientacion-vocacional">Orientación vocacional</router-link-->
                <!--router-link class="dropdown-item" to="/habilidades-intervencion-psicooncologica">Habilidades de Intervención Psicooncológica</router-link-->
                <!--router-link class="dropdown-item" to="/cursoTEA">TEA (Trastornos del Espectro Autista)</router-link-->
                <!--router-link class="dropdown-item" to="/cursoAuxiliarEnfermeria">Curso Teórico Práctico para Auxiliar en Enfermería</router-link-->
                <!--router-link class="dropdown-item" to="/psicologia-rostro-cuerpo">Psicología de Rostro y Cuerpo</router-link-->
                <!--router-link class="dropdown-item" to="/curso-intervencion-tanatologica">Técnicas de Intervención Tanatológicas</router-link-->
                <!--router-link class="dropdown-item" to="/sanandoArbol">Sanando mi Árbol Genealógico</router-link-->
                <!--router-link class="dropdown-item" to="/autoestima">Autoestima</router-link-->
                <!--router-link class="dropdown-item" to="/neurodesarrollo">Neurodesarrollo</router-link-->
                <!--router-link class="dropdown-item" to="/sociedad-matematica">Sociedad Matemática Secreta</router-link-->
                <!--router-link class="dropdown-item" to="/tablas-matematicas">Tablas de Excel para Matemáticas Financieras</router-link-->
                <!--router-link class="dropdown-item" to="/toma-muestras-biologicas">Toma de Muestras Biológicas</router-link-->
                <!--router-link class="dropdown-item" to="/cursos-adicciones">Adicciones</router-link-->
                <!--router-link class="dropdown-item" to="/tablas-excel-basico">Tablas de Excel Básico</router-link-->
                <!--router-link class="dropdown-item" to="/suenno-transtornos">El Sueño y sus Transtornos</router-link-->
                <!--router-link class="dropdown-item" to="/bioenergetica-terapia-movimiento">Bioenergética de la Terapia en Movimiento</router-link-->
                <!--router-link class="dropdown-item" to="/intervencion-psicooncologica">Intervención Psicooncológica</router-link-->
                <!--router-link class="dropdown-item" to="/principios-grafologia">Principios de la Grafología</router-link-->
                <!--router-link class="dropdown-item" to="/eneagrama-transpersonal">Eneagrama Transpersonal</router-link-->
                <!--router-link class="dropdown-item" to="/terapia-gerontologica">Terapia Gerontológica para Adultos Mayores</router-link-->
                <!-- <router-link class="dropdown-item" to="/actualizacion-metodologica-en-trabajo-social">
                  Actualización Metodológica en Trabajo Social
                </router-link> -->
                <!-- <router-link class="dropdown-item" to="/elaboracion-de-instrumentos-en-el-trabajo-social">
                  Elaboración de Instrumentos en el Trabajo Social
                </router-link> -->
                <!-- <router-link class="dropdown-item" to="/leyendo-a-michel-foucalt">
                  Leyendo a Michel Foucalt
                </router-link> -->
                <!-- <router-link
class="dropdown-item"
to="/invitacion-al-pensamiento-critico"
>Invitación al pensamiento crítico</router-link
> -->
              </div>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/cursoAuxiliarEnfermeria">Curso de Enfermería</router-link>
            </li>
            <li class="nav-item dropdown">
              <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdownMenuLink" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Diplomados
              </router-link>
              <transition name="bounce">
                <div class="dropdown-menu drop-up ordenarm1" aria-labelledby="navbarDropdownMenuLink">
                  <!-- <router-link class="dropdown-item text-wrap" to="/abordaje-de-las-violencias-y-la-perspectiva-de-género">Abordaje de las violencias y la perspectiva de género</router-link> -->
                  <!--router-link class="dropdown-item" to="comunicacion-no-verbal">Psicología de la verdad, comunicación no verbal...</router-link-->
                  <router-link class="dropdown-item" to="/transtorno-deficit">Transtornos por Déficit de Atención e Hiperactividad</router-link>
                  <router-link class="dropdown-item" to="/hipnosis">Hipnosis</router-link>
                  <router-link class="dropdown-item" to="/desarrollo-organizacional-gestion-cambio">Desarrollo Organizacional y Gestión del Cambio</router-link>
                <!--router-link class="dropdown-item" to="/criminalistica">Criminalística</router-link-->
                  <!-- <router-link class="dropdown-item" to="/administracion-y-finanzas">
                    Administración y Finanzas
                  </router-link> -->
                  <!--router-link class="dropdown-item" to="/educacion-integral-de-la-sexualidad">Sexualidad</router-link-->
                  <!--router-link class="dropdown-item" to="/juicios-orales">Juicios Orales en Materia Penal</router-link-->
                  <router-link class="dropdown-item" to="/pruebas-psicologicas">Pruebas Psicológicas</router-link>
                  <router-link class="dropdown-item" to="/psicopatología">Psicopatología</router-link>
                  <!-- <router-link class="dropdown-item" to="/psicoterapia-para-niños-con-discapacidad">Psicoterapia para niños con discapacidad</router-link> -->
                  <router-link class="dropdown-item" to="/psicoterapia-transpersonal-integrativa">Psicoterapia Transpersonal</router-link>
                  <router-link class="dropdown-item" to="/tanatologia-transpersonal">Tanatología Transpersonal</router-link>
                  <!--router-link class="dropdown-item" to="/terapia-de-lenguaje">Terapia de lenguaje</router-link-->
                  <router-link class="dropdown-item" to="/terapia-de-juego">Terapia de Juego</router-link>
                  <router-link class="dropdown-item" to="/terapia-de-pareja-y-sexualidad">Terapia de Pareja y Sexualidad</router-link>
                  <router-link class="dropdown-item" to="/terapia-familiar">Terapia Familiar</router-link>
                  <router-link class="dropdown-item" to="/tecnicas-estrategias-neurociencia">Técnicas y Estrategias Psicoterapéuticas de Neurociencia</router-link>
                  <!--router-link class="dropdown-item" to="/urgencias-psicologicas">Urgencias Psicológicas</router-link-->
                  <!-- <router-link class="dropdown-item" to="/bases-clinicas-de-la-gerontología">Bases clínicas de la gerontología</router-link> -->
                  <!-- <router-link class="dropdown-item" to="/interdisciplinario-en-Derechos-Humanos">Interdisciplinario en Derechos Humanos</router-link> -->
                  <!-- <router-link
class="dropdown-item"
to="/multidisciplinario-en-derechos-humanos"
>Multidisciplinario en Derechos Humanos</router-link
> -->
                  <!-- <router-link
class="dropdown-item"
to="/trastorno-del-espectro-autista-TEA"
>Trastorno del espectro autista TEA</router-link
> -->
                  <!-- <router-link class="dropdown-item" to="/diagnóstico-clínico-a-través-del-cine">Diagnóstico Clínico a Través del Cine</router-link> -->
                  <!-- <router-link class="dropdown-item" to="/introducción-a-diversos-pensamientos-filosóficos">Introducción a diversos pensamientos filosóficos</router-link> -->
                  <!--router-link class="dropdown-item" to="/dificultades-y-trastornos-en-el-aprendizaje">Dificultades y trastornos del aprendizaje</router-link-->
                  <!--router-link class="dropdown-item" to="/tecnicas-neuro-ingenieria">Técnicas de neuro ingeniería y Diseño de Ingeniería humana</router-link-->
                  <router-link class="dropdown-item" to="/habilidades-clínicas">Habilidades clínicas</router-link>
                  <!--router-link class="dropdown-item" to="/derechos-humanos">Derechos Humanos</router-link-->
                  <!--router-link class="dropdown-item" to="/cuidados-paliativos">Cuidados Paliativos</router-link-->
                  <!--router-link class="dropdown-item" to="/psicotrauma">Psicotrauma</router-link-->
                  <!--router-link class="dropdown-item" to="/herramientas-psicologicas-gestion">Herramientas Psicológicas para la Gestión de Emociones</router-link-->
                  <!--router-link class="dropdown-item" to="/capital-humano">Capital Humano (RRHH)</router-link-->
                  <!--router-link class="dropdown-item" to="/derecho-corporativo">Derecho Corporativo</router-link-->
                  <!--router-link class="dropdown-item" to="/acompannamiento-psicologico-crianza-ninnez">Acompañamiento Psicológico en Crianza y Desarrollo en Niñez</router-link-->
                  <!--router-link class="dropdown-item" to="/juicios-orales-civiles-familiares">Juicios Orales Código de Procedimientos Civiles y Familiares</router-link-->
                  <router-link class="dropdown-item" to="/juicios-amparo">Juicios de Amparo</router-link>
                  <!--router-link class="dropdown-item" to="/ia-transformacion-digital">IA y Transformación Digital</router-link-->
                  <!--router-link class="dropdown-item" to="/tecnicas-masajes-terapias">Técnicas de Masajes y Terapias Complementarias</router-link-->
                  <!--router-link class="dropdown-item" to="/herramientas-metodologicas-trabajo-social">Herramientas Metodológicas de Trabajo Social, Práctica Integral</router-link-->
                  <!--router-link class="dropdown-item" to="/transformacion-digital-organizaciones">Transformacion Digital en las Organizaciones</router-link-->
                  <!--router-link class="dropdown-item" to="/diplomado-suicidio">Suicidio</router-link-->
                  <!-- <router-link class="dropdown-item" to="/administración-base-de-la-gestión-escolar">Administración, base de la gestión escolar</router-link> -->
                  <!-- <router-link
class="dropdown-item"
to="/Intervención-e-identificación-en-el-TDAH"
>Intervención e identificación en el TDAH</router-link
> -->
                  <!-- <router-link
class="dropdown-item"
to="/psicomotrocidad-infantil"
>Psicomotricidad infantil</router-link
> -->
                  <!-- <router-link class="dropdown-item" to="/terapia-juego-ii"
>Terapia de Juego II</router-link
> -->
                  <!--router-link class="dropdown-item" to="/estrategias-litigacion-penal">Estrategias de Litigación en Materia Penal</router-link-->
                  <!--router-link class="dropdown-item" to="/espiritualidad-religion-sanacion">Espiritualidad, Religión y Sanación</router-link-->
                  <router-link class="dropdown-item" to="/psicologia-juridica">Psicología Jurídica, Forense y Perfilación Criminológica</router-link>
                  <router-link class="dropdown-item" to="/trabajo-social-herramientas">Trabajo Social y sus Herramientas</router-link>
                  <!--router-link class="dropdown-item" to="/gestion-empresarial-emprendimiento">Gestión Empresarial - Emprendimiento 360°</router-link-->
                  <!--router-link class="dropdown-item" to="/escena-crimen-analisis-forense">Escena del Crimen y Análisis Forense</router-link-->
                  <router-link class="dropdown-item" to="/meditacion-enfoque-transpersonal">Meditación con Enfoque Transpersonal</router-link>
                  <!--router-link class="dropdown-item" to="/desarrollo-organizacional-change-management">Desarrollo Organizacional: Conducta y Change Management</router-link-->
                  <!--router-link class="dropdown-item" to="/transformacion-digital-ia">Transformación Digital + IA</router-link-->
                  <!--router-link class="dropdown-item" to="/metodos-alternos-solucion-conflictos">Métodos Alternos de Solución de Confllictos</router-link-->
                  <!--router-link class="dropdown-item" to="/derechos-psicologos-mexicanos">Derecho para Psicólogos y Psicólogas Mexicanos</router-link-->
                </div>
              </transition>
            </li>
            <li class="nav-item dropdown">
              <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdownMenuLink" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Talleres
              </router-link>
              <div class="dropdown-menu drop-up ordenarm2" aria-labelledby="navbarDropdownMenuLink">
                <!--router-link class="dropdown-item" to="/acoso-escolar">Acoso Escolar</router-link-->
                <!-- <router-link class="dropdown-item" to="/amor-a-mi-vejez">Amor a mi vejez</router-link> -->
                <router-link class="dropdown-item" to="/aprendiendo-a-perdonar">Aprendiendo a Perdonar</router-link>
                <router-link class="dropdown-item" to="/autoestima">Autoestima</router-link>
                <!--router-link class="dropdown-item" to="/vision-accion">De la Visión a la Acción</router-link-->
                <!--router-link class="dropdown-item" to="/disenna-metas-2026">Diseña tus Metas para 2026</router-link-->
                <!-- <router-link class="dropdown-item" to="/cerrando-heridas">Cerrando heridas</router-link> -->

                <!-- <router-link class="dropdown-item" to="/aprendiento-a-perdonar-me">Aprendiendo a perdonar-me</router-link> -->
                <!--router-link class="dropdown-item" to="/la-muerte-para-los-abogados-desde-la-mirada-humana-y-legal">La muerte para los abogados desde la mirada humana y legal</router-link-->
                <!--router-link class="dropdown-item" to="/el-dolor-de-decir-adios">El dolor de decir adiós</router-link-->
                <!--router-link class="dropdown-item" to="/aprendiendo-a-enveje-ser">Aprendiendo a enveje-ser</router-link-->
                <!--router-link class="dropdown-item" to="/demandas-juridicas">Demandas jurídicas</router-link-->
                <!--router-link class="dropdown-item" to="/autohomenaje-y-placer-femenino-como-forma-de-tracendencia">Autohomenaje y placer femenino como forma de trascendencia</router-link-->
                <!-- <router-link class="dropdown-item" to="/homenaje-a-mi-pareja"
>Homenaje a mi Pareja</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/temor-contingencia-sanitaria"
>Duelo y temor ante el contexto actual sanitario</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/duelo-ganancias-covid"
>Duelo y ganancias ante el COVID-19</router-link
> -->
                <!--router-link class="dropdown-item" to="/codependencia">Codependencia</router-link-->
                <router-link class="dropdown-item" to="/poner-limites">¿Porqué nos Cuesta Trabajo Poner Límites?</router-link>
                <router-link class="dropdown-item" to="/iniciando-anno-significado">Iniciando tu Año con Significado</router-link>
                <router-link class="dropdown-item" to="/del-derecho-administracion">Del Derecho a la Administración</router-link>
                <router-link class="dropdown-item" to="/entre-salud-ley">Entre la Salud y la Ley</router-link>
                <router-link class="dropdown-item" to="/neurodiversidad-inclusion">Neurodiversidad e Inclusión</router-link>
                <router-link class="dropdown-item" to="/morir-derecho">¿Morir es un Derecho?</router-link>
                <!-- <router-link class="dropdown-item" to="/descubriendo-mi-poder"
>Descubriendo mi poder</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/cuidando-del-cuidador">Cuidando del cuidador</router-link> -->
                <!-- <router-link class="dropdown-item" to="/despidiendo-mi-año"
>Despidiendo mi año</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/reencontrando-a-mi-niño-interior">Reencontrando a mi niño interior</router-link> -->
                <!-- <router-link class="dropdown-item" to="/risoterapia">Risoterapia</router-link> -->
                <router-link class="dropdown-item" to="/viviendo-mi-propia-muerte">Viviendo mi propia muerte</router-link>
                <!-- <router-link class="dropdown-item" to="/violencia-covid"
>Violencia durante y después del COVID-19</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/perdonar-contingencia"
>Aprendiendo a perdonar durante la Contingencia</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/psicogenealogia"
>Psicogenealogía</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/duelo-covid"
>Duelo ante el COVID-19</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/sanando-heridas-covid"
>Sanando Héridas en época de COVID-19</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/yoga-de-la-risa">Yoga de la risa</router-link> -->
                <!-- <router-link class="dropdown-item" to="/yoga-transpersonal">Yoga transpersonal</router-link> -->
                <!-- <router-link class="dropdown-item" to="/taller-diagnóstico-clínico-a-través-del-cine">Diagnóstico del Trastorno Mayor a Través del Cine</router-link> -->
                <!-- <router-link class="dropdown-item" to="/mandalas-meditación-activa">Mandalas meditación activa</router-link> -->
                <!-- <router-link class="dropdown-item" to="/atención-de-personas-que-viven-con-VIH">Atención de personas que viven con VIH</router-link> -->
                <!-- <router-link class="dropdown-item" to="/taller-expresión-en-público">Expresión en público</router-link> -->
                <!-- <router-link
class="dropdown-item"
to="/taller-sanacion-de-emociones"
>Sanación de emociones</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/despertando-mis-recursos-internos-ante-el-covid-19"
>Despertando mis recursos internos ante el
COVID-19</router-link
> -->
                <!-- <router-link class="dropdown-item" to="/cerrando-mi-año"
>Cerrando mi año</router-link
> -->
                <!--router-link class="dropdown-item" to="/cerrando-transpersonal">Cerrando ciclos</router-link-->
                <!-- <router-link
class="dropdown-item"
to="/2021-Una-Nueva-Oportunidad"
>2022, Una Nueva Oportunidad</router-link
> -->
                <router-link class="dropdown-item" to="/duelo">Duelo</router-link>
                <!--router-link class="dropdown-item" to="/morfopsicologia-arrugas">Morfopsicología (Análisis de las Arrugas)</router-link-->
                <!--router-link class="dropdown-item" to="/aulas-creativas">Formación de Aulas Creativas</router-link-->
                <!--router-link class="dropdown-item" to="/encuentro-ancestros">Encuentro con mis ancestros</router-link-->
                <!--router-link class="dropdown-item" to="/activa-potencial">Activa tu Potencial y Empodérate</router-link-->
                <!--router-link class="dropdown-item" to="/aprendiendo-jugando">Aprendiendo jugando</router-link-->
                <!--router-link class="dropdown-item" to="/despertando-ser-interior">Despertando tu ser Interior</router-link-->
                <!--router-link class="dropdown-item" to="/elaboracion-informe-psicopedagogico">Elaboración del Informe Psicopedagógico</router-link-->
                <!--router-link class="dropdown-item" to="/aplicaciones-inversion">Aplicaciones para Inversión</router-link-->
                <!--router-link class="dropdown-item" to="/tinker-cad">Diseño y Modelado en Tinkercad</router-link-->
                <!--router-link class="dropdown-item" to="/simulador-mercados">Simulador de Mercados</router-link-->
                <!--router-link class="dropdown-item" to="/violencia-escolar">Alto a la Violencia Escolar</router-link-->
                <!--router-link class="dropdown-item" to="/titeres-recurso-didactico">Títeres como Recurso Didáctico</router-link-->
                <!--router-link class="dropdown-item" to="/repaso-neuroanatomia">Un Repaso a la Neuroanatomía</router-link-->
                <!--router-link class="dropdown-item" to="/metas-proposito">Creando Metas con Propósito</router-link-->
                <router-link class="dropdown-item" to="/heridas-nacimiento">Sanando Heridas de Nacimiento</router-link>
                <router-link class="dropdown-item" to="/amor-codependencia">¿Amor o Codependencia?</router-link>
                <!--router-link class="dropdown-item" to="/explorando-sexualidad">Explorando mi Sexualidad</router-link-->
                <!--router-link class="dropdown-item" to="/importancia-juego-infancias">La importancia del Juego en las infancias</router-link-->
                <!--router-link class="dropdown-item" to="/aprendiendo-amarme">Aprendiendo a Amarme</router-link-->
                <!--router-link class="dropdown-item" to="/intervencion-dificultades-aprendizaje">Dificultades del Aprendizaje</router-link-->
                <!--router-link class="dropdown-item" to="/aprendiendo-comunicarme">Aprendiendo a Comunicarnos</router-link-->
                <!--router-link class="dropdown-item" to="/tecnicas-ludicas-adulto">Técnicas Lúdicas para el adulto mayor</router-link-->
                <!--router-link class="dropdown-item" to="/importancia-ed-sexual-infancias">Importancia de la Educación Sexual en las Infancias</router-link-->
                <!--router-link class="dropdown-item" to="/cuento-muerte">Cuento - Recurso didáctico para niños para abordar la muerte</router-link-->
                <!--router-link class="dropdown-item" to="/estimulacion-lenguaje-03">La Estimulación del Lenguaje en Infantes de 0 a 3 años</router-link-->
                <!--router-link class="dropdown-item" to="/sexualidad-placentera-etapa-adulta">Sexualidad Placentera en la Etapa Adulta</router-link-->
                <!--router-link class="dropdown-item" to="/tecnicas-intervencion-tanatologicas">Técnicas de Intervención Tanatológicas</router-link-->
                <router-link class="dropdown-item" to="/inmersion-sonora">Sesión de Inmersión Sonora</router-link>
                <!--router-link class="dropdown-item" to="/cuento-recurso-socioemocional">El Cuento como Recurso Socioemocional</router-link-->
                <!--router-link class="dropdown-item" to="/nuevo-proceso-civil-familiar">Nuevo Proceso Civil y Familiar</router-link-->
                <router-link class="dropdown-item" to="/transformar-dolor-significado">Transformar el Dolor en Significado</router-link>
                <router-link class="dropdown-item" to="/construyendo-anno-proposito">Construyendo el Año con Propósito</router-link>
                <router-link class="dropdown-item" to="/renacer-despues-adversidad">Renacer Después de la Adversidad</router-link>
                <!--router-link class="dropdown-item" to="/autoconocimiento">Autoconocimiento</router-link-->
                <!--router-link class="dropdown-item" to="/elaboracion-demandas">Elaboración de Demandas</router-link-->
                <!--router-link class="dropdown-item" to="/plenaria-posesion">Plenaria de Posesión o Publiciana</router-link-->
                <!--router-link class="dropdown-item" to="/inteligencia-emocional">Inteligencia Emocional para la Vida</router-link-->
                <!-- <router-link
class="dropdown-item"
to="/Afrontamiento-Ante-El-Estres-Escolar-Madres-Y-Padres"
>Afrontamiento Ante El Estrés Escolar: Madres Y
Padres</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/tecnicas-para-afrontar-la-ansiedad-provocada-por-la-pandemia"
>Técnicas para afrontar la ansiedad provocada por la
pandemia</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/terapia-ocupacional-para-el-adulto-mayor-en-el-confinamiento"
>Terapia ocupacional para el adulto mayor en el
confinamiento</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/la-risa-y-el-humor-como-recurso-de-afrontamiento-ante-la-pandemia"
>Taller la risa y el humor como recurso de afrontamiento ante
la pandemia</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/motivacion-y-plenitud-en-el-entorno-escolar"
>Motivación y plenitud en el entorno escolar</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/regreso-a-la-normalidad-en-las-escuelas"
>Regreso a la normalidad en las escuelas</router-link
> -->
                <!-- <router-link
class="dropdown-item"
to="/mitos-del-amor-romantico"
>Mitos del amor romántico</router-link
> -->
              </div>
            </li>
            <!-- <li class="nav-item dropdown">
              <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdownMenuLink" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Seminarios
              </router-link>
              <div class="dropdown-menu drop-up" aria-labelledby="navbarDropdownMenuLink">
                <router-link class="dropdown-item" to="/preparatorio-de-investigacion">Preparatorio de investigación
                </router-link>
                <router-link class="dropdown-item" to="/sociología-del-suicidio">Sociología del suicidio</router-link>
              </div>
            </li> -->
            <!--li class="nav-item dropdown">
              <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdownMenuLink" role="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Conócenos
              </router-link>
              <div class="dropdown-menu drop-up" aria-labelledby="navbarDropdownMenuLink">
                <router-link class="dropdown-item" to="/historia-academica">Historia</router-link>
                <router-link class="dropdown-item" to="/nuestros-objetivos">Nuestros objetivos</router-link>
                <router-link class="dropdown-item" to="/nuestra-filosofía">Nuestra filosofía</router-link>
              </div>
            </li-->
            <li class="nav-item">
              <router-link class="nav-link" to="/becas">Becas por Convenio</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/clínica-psicoterapéutica">Clínica psicoterapéutica</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/parkinson">Parkinson</router-link>
            </li>
            <!--li class="nav-item">
              <router-link class="nav-link" to="/eventos-del-mes">Eventos del mes</router-link>
            </li-->
            <li class="nav-item">
              <router-link class="nav-link" to="/contactanos">Contáctanos</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <section>
      <div>
        <transition name="fade" mode="out-in">
          <keep-alive>
            <router-view />
          </keep-alive>
        </transition>
      </div>
    </section>

    <eventarticulos></eventarticulos>
    <!--Sitios de interes-->
    <!--section class="mt-3">
      <video src="https://www.impo.org.mx/videos/congresoTanatologia.mp4" controls></video>
      <p><a href="https://www.impo.org.mx/congreso-de-tanatologia-estudios" target="_blank" style="font-size:22px;">Ver programa aquí...</a></p>
    </section-->
    <section class="mt-3">
      <div class="container">
        <h2>Sitios de interés</h2>
        <carousel :nav="false" :autoplay="true" :margin="10" :responsive="{
          0: { items: 1 },
          600: { items: 3 },
          800: { items: 5 }
        }" :dots="false">
          <div>
            <a href="https://www.impo.org.mx/" target="_blank" rel="noopener noreferrer"><img
                src="@/assets/images/logos/logo_impo.png" alt="Logo IMPo" /></a>
          </div>
          <div>
            <a href="https://www.estudiosdeposgrado.org.mx/" target="_blank" rel="noopener noreferrer"><img
                src="@/assets/images/logos/logo_imesp.png" alt="Logo IMESP" /></a>
          </div>
          <div>
            <a href="https://impobachillerato.org.mx/" target="_blank" rel="noopener noreferrer"><img
                src="@/assets/images/logos/logo_impoBachillerato.png" alt="Logo IMPo Bachillerato" /></a>
          </div>
          <div>
            <a href="https://radioimpo.com.mx/" target="_blank" rel="noopener noreferrer"><img
                src="@/assets/images/logos/logo_radioImpo.png" alt="Logo Radio IMPo" /></a>
          </div>
          <!--div>
            <a href="https://escuelanormalimpo.org.mx/" target="_blank" rel="noopener noreferrer"><img
                src="@/assets/images/logos/impo_normal.png" alt="Escuela Normal IMPo" /></a>
          </div-->
          <div>
            <a href="https://colegiodetanatologos.com/" target="_blank" rel="noopener noreferrer"><img
                src="https://colegiodetanatologos.com/images/logo_colegio.svg" alt="Colegio de Tanatologos"
                style="height:88.633px;" /></a>
          </div>
        </carousel>
      </div>
    </section>
    <!--Sitios de interes-->
    <div></div>
    <footer class="pt-4">
      <div class="container pb-4">
        <div class="row">
          <div class="col-md">
            <img src="@/assets/images/logo.png" alt="IMPo" class="logo img-fluid" />
            <nav class="nav flex-column menu-footer vineta mt-2">
              <router-link to="/historia-academica">Conócenos</router-link>
              <a href="https://www.impo.org.mx/revista-thanatos" target="_blank" rel="noopener noreferrer">Revista
                Thanatos</a>
              <!--router-link to="/sitios-de-interes">Sitios de Interés</router-link-->
              <!--a href="https://escuelanormalimpo.org.mx" target="_blank"> Escuela Normal IMPo</a-->
              <!-- <router-link to="/galeria">Galería</router-link> -->
            </nav>
            <h3>Contáctanos</h3>
            <p>
              <i class="fas fa-building"></i> Montevideo<br />
              <span style="font-size: 20px" class="ml-3"><i class="fas fa-phone"></i> 55 6393-1100</span>
            </p>
            <p>
              <i class="fas fa-building"></i> Tláhuac<br />
              <span style="font-size: 20px" class="ml-3"><i class="fas fa-phone"></i> 55 6819-2000</span>
            </p>
            <p>
              <i class="fas fa-building"></i> Tlalpan<br />
              <span style="font-size: 20px" class="ml-3"><i class="fas fa-phone"></i> 55 6393-2000</span>
            </p>
          </div>
          <div class="col-md">
            <h3>Cursos</h3>
            <nav class="nav flex-column menu-footer vineta ordenarf3">
              <!--router-link to="/cursos-adicciones">Adicciones</router-link-->
              <!--router-link to="/glandula-pineal">Glándula Pineal</router-link-->
              <!--router-link to="/principios-grafologia">Principios de la Grafología</router-link-->
              <!--router-link to="/psicologia-rostro-cuerpo">Psicología de Rostro y Cuerpo</router-link-->
              <!--router-link to="/sanandoArbol">Sanando mi Árbol Genealógico</router-link-->
              <!--router-link to="/eneagrama-transpersonal">Eneagrama Transpersonal</router-link-->
              <!--router-link to="/tablas-matematicas">Tablas de Excel para Matemáticas Financieras</router-link-->
              <!--router-link to="/toma-muestras-biologicas">Toma de Muestras Biológicas</router-link-->
              <!--router-link to="/examinación-del-estado-mental">Examinación del estado mental</router-link-->
              <router-link to="/inteligencia-emocional-aplicada">Inteligencia Emocional Aplicada</router-link>
              <router-link to="/intervencion-psicosocial-integrativa">Intervención Psicosocial Integrativa</router-link>
              <router-link to="/cursoAuxiliarEnfermeria">Curso Práctico Teórico Auxiliar en Enfermería</router-link>
                <!--router-link to="/primeros-auxilios-basicos">Primeros Auxilios Básicos</router-link-->
              <!--router-link to="/tablas-excel-medio">Tablas de Excel Nivel Medio</router-link-->
              <!--router-link to="/disena-impacta-chatgpt-canva">Diseña e Impacta con ChatGPT</router-link-->
              <!--router-link to="/conexion-cuantico-psicoterapia">Conexión Mundo Cuántico y Psicoterapia Transpersonal</router-link-->
              <!--router-link to="/sanando-heridas-transgeneracionales">Sanando Heridas Transgeneracionales</router-link-->
              <!--router-link to="/resolviendo-duelos">Resolviendo mis Duelos</router-link-->
              <!--router-link to="/curso-intervencion-tanatologica">Técnicas de Intervención Tanatológicas</router-link-->
              <!--router-link to="/psicofarmacologia-para-psicologos">Psicofarmacología</router-link-->
              <!--router-link to="/tablas-excel-basico">Tablas de Excel Básico</router-link-->
              <!--router-link to="/suenno-transtornos">El Sueño y sus Transtornos</router-link-->
              <!--router-link to="/bioenergetica-terapia-movimiento">Bioenergética de la Terapia en Movimiento</router-link-->
              <!--router-link to="/intervencion-psicooncologica">Intervención Psicooncológica</router-link-->
            </nav>
          </div>
          <div class="col-md">
            <h3>Diplomados</h3>
            <nav class="nav flex-column menu-footer vineta ordenarf1">
              <router-link to="/transtorno-deficit">Transtornos por Déficit de Atención e Hiperactividad</router-link>
              <router-link to="/habilidades-clínicas">Habilidades clínicas</router-link>
              <!--router-link to="/criminalistica">Criminalística</router-link-->
              <!-- <router-link to="/abordaje-de-las-violencias-y-la-perspectiva-de-género">Abordaje de las violencias y la perspectiva de género</router-link> -->
              <!-- <router-link class="dropdown-item" to="/administración-base-de-la-gestión-escolar">Administración, base de la gestión escolar</router-link> -->
              <!--router-link to="/juicios-orales">Juicios Orales en Materia Penal</router-link-->
              <router-link to="/pruebas-psicologicas">Pruebas Psicológicas</router-link>
              <!--router-link to="/educacion-integral-de-la-sexualidad">Sexualidad</router-link-->
              <!-- <router-link to="/psicoterapia-para-niños-con-discapacidad">Psicoterapia para niños con discapacidad</router-link> -->
              <router-link to="/psicoterapia-transpersonal-integrativa">Psicoterapia Transpersonal</router-link>
              <router-link to="/tanatologia-transpersonal">Tanatología Transpersonal</router-link>
              <!--router-link to="/terapia-de-lenguaje">Terapia de lenguaje</router-link-->
              <router-link to="/terapia-de-juego">Terapia de Juego</router-link>
              <router-link to="/terapia-de-pareja-y-sexualidad">Terapia de Pareja y Sexualidad</router-link>
              <router-link to="/terapia-familiar">Terapia Familiar</router-link>
              <router-link to="/tecnicas-estrategias-neurociencia">Técnicas y Estrategias Psicoterapéuticas de Neurociencia</router-link>
              <router-link to="/desarrollo-organizacional-gestion-cambio">Desarrollo Organizacional y Gestión del Cambio</router-link>
              <!--router-link to="/urgencias-psicologicas">Urgencias Psicológicas</router-link-->
              <!-- <router-link to="/bases-clinicas-de-la-gerontología">Bases clínicas de la gerontología</router-link> -->
              <!-- <router-link to="/interdisciplinario-en-Derechos-Humanos">Interdisciplinario en Derechos Humanos</router-link> -->
              <!-- <router-link to="/multidisciplinario-en-derechos-humanos"
>Multidisciplinario en Derechos Humanos</router-link
> -->
              <!-- <router-link to="/trastorno-del-espectro-autista-TEA"
>Trastorno del espectro autista TEA</router-link
> -->
              <!-- <router-link to="/diagnóstico-clínico-a-través-del-cine">Diagnóstico Clínico a Través del Cine</router-link> -->
              <!-- <router-link to="/introducción-a-diversos-pensamientos-filosóficos">Introducción a diversos pensamientos filosóficos</router-link> -->
              <!--router-link to="/dificultades-y-trastornos-en-el-aprendizaje">Dificultades y trastornos del aprendizaje</router-link-->
              <!-- <router-link to="/terapia-juego-ii"
>Terapia de Juego II</router-link
> -->
              <!--router-link to="/espiritualidad-religion-sanacion">Espiritualidad, Religión y Sanación</router-link-->
              <!--router-link to="comunicacion-no-verbal">Psicología de la verdad, comunicación no verbal...</router-link-->
              <!--router-link to="/estrategias-litigacion-penal">Estrategias de Litigación en Materia Penal</router-link-->
              <router-link to="/hipnosis">Hipnosis</router-link>
              <!--router-link to="/derechos-humanos">Derechos Humanos</router-link-->
              <!--router-link to="/cuidados-paliativos">Cuidados Paliativos</router-link-->
              <!--router-link to="/psicotrauma">Psicotrauma</router-link-->
              <!--router-link to="/capital-humano">Capital Humano (RRHH)</router-link-->
              <!--router-link to="/derecho-corporativo">Derecho Corporativo</router-link-->
              <!--router-link to="/acompannamiento-psicologico-crianza-ninnez">Acompañamiento Psicológico en Crianza y Desarrollo en Niñez</router-link-->
              <!--router-link to="/tecnicas-masajes-terapias">Técnicas de Masajes y Terapias Complementarias</router-link-->
              <router-link to="/trabajo-social-herramientas">Trabajo Social y sus Herramientas</router-link>
              <!--router-link to="/herramientas-psicologicas-gestion">Herramientas Psicológicas para la Gestión de Emociones</router-link-->
              <!--router-link to="/juicios-orales-civiles-familiares">Juicios Orales Código de Procedimientos Civiles y Familiares</router-link-->
              <!--router-link to="/herramientas-metodologicas-trabajo-social">Herramientas Metodológicas de Trabajo Social y su Práctica Integral</router-link-->
              <!--router-link to="/transformacion-digital-organizaciones">Transformación Digital en las Organizaciones</router-link-->
              <!--router-link to="/diplomado-suicidio">Suicidio</router-link-->
              <!--router-link to="/tecnicas-neuro-ingenieria">Técnicas de neuro ingeniería y Diseño de Ingeniería humana</router-link-->
              <!--router-link to="/metodos-alternos-solucion-conflictos">Métodos Alternos de Solución de Conflictos</router-link-->
              <router-link to="/psicopatología">Psicopatología</router-link>
              <router-link to="/psicologia-juridica">Psicología Jurídica, Forense y Perfilación Criminológica</router-link>
              <!--router-link to="/trabajo-social-herramientas">Trabajo Social y sus Herramientas</router-link-->
              <!--router-link to="/gestion-empresarial-emprendimiento">Gestión Empresarial - Emprendimiento 360°</router-link-->
              <!--router-link to="/escena-crimen-analisis-forense">Escena del Crimen y Análisis Forense</router-link-->
              <router-link to="/meditacion-enfoque-transpersonal">Meditación con Enfoque Transpersonal</router-link>
              <!--router-link to="/desarrollo-organizacional-change-management">Desarrollo Organizacional: Conducta y Change Management</router-link-->
              <!--router-link to="/transformacion-digital-ia">Transformación Digital + IA</router-link-->
              <router-link to="/juicios-amparo">Juicios de Amparo</router-link>
              <!--router-link to="/ia-transformacion-digital">IA y Transformación Digital</router-link-->
              <!--router-link to="/derechos-psicologos-mexicanos">Derecho para Psicólogos y Psicólogas Mexicanos</router-link-->
            </nav>
          </div>
          <div class="col-md">
            <h3>Talleres</h3>
            <nav class="nav flex-column menu-footer vineta ordenarf2">
              <router-link to="/autoestima">Autoestima</router-link>
              <!--router-link to="/disenna-metas-2026">Diseña tus Metas para 2026</router-link-->
              <!--router-link to="/vision-accion">De la Visión a la Acción</router-link-->
              <router-link to="/aprendiendo-a-perdonar">Aprendiendo a Perdonar</router-link>
              <!--router-link to="/aprendiendo-a-enveje-ser">Aprendiendo a enveje-ser</router-link-->
              <!--router-link to="/el-dolor-de-decir-adios">El dolor de decir adios</router-link-->
              <!--router-link to="/la-muerte-para-los-abogados-desde-la-mirada-humana-y-legal">La muerte para los abogados desde la mirada humana y legal</router-link-->
              <!--router-link to="/demandas-juridicas">Demandas jurídicas</router-link-->
              <router-link to="/poner-limites">¿Porqué nos Cuesta Trabajo Poner Límites?</router-link>
              <router-link to="/iniciando-anno-significado">Iniciando tu Añó con Significado</router-link>
              <router-link to="/del-derecho-administracion">Del Derecho a la Administración</router-link>
              <router-link to="/entre-salud-ley">Entre la Salud y la Ley</router-link>
              <router-link to="/neurodiversidad-inclusion">Neurodiversidad e Inclusión</router-link>
              <router-link to="/morir-derecho">¿Morir es un Derecho?</router-link>
              <!--router-link to="/cerrando-transpersonal">Cerrando ciclos</router-link-->
              <!--router-link to="/acoso-escolar">Acoso Escolar</router-link-->
              <!--router-link to="/autohomenaje-y-placer-femenino-como-forma-de-tracendencia">Autohomenaje y placer femenino como forma de trascendencia</router-link-->
              <!--router-link to="/codependencia">Codependencia</router-link-->
              <!-- <router-link to="/descubriendo-mi-poder"
>Descubriendo mi poder</router-link
> -->
              <router-link to="/viviendo-mi-propia-muerte" >Viviendo mi propia muerte</router-link>
              <router-link to="/duelo">Duelo</router-link>
              <!--router-link to="/morfopsicologia-arrugas">Morfopsicología (Análisis de las Arrugas)</router-link-->
              <!--router-link to="/aulas-creativas">Formación de Aulas Creativas</router-link-->
              <!--router-link to="/encuentro-ancestros">Encuentro con mis ancestros</router-link-->
              <!--router-link to="/activa-potencial">Activa tu Potencial y Empodérate</router-link-->
              <!--router-link to="/aprendiendo-jugando">Aprendiendo jugando</router-link-->
              <!--router-link to="/despertando-ser-interior">Despertando tu ser Interior</router-link-->
              <!--router-link to="/elaboracion-informe-psicopedagogico">Elaboración del Informe Psicopedagógico</router-link-->
              <!--router-link to="/aplicaciones-inversion">Aplicaciones para Inversión</router-link-->
              <!--router-link to="/tinker-cad">Diseño y Modelado en Tinkercad</router-link-->
              <!--router-link to="/simulador-mercados">Simulador de Mercados</router-link-->
              <!--router-link to="/violencia-escolar">Alto a la Violencia Escolar</router-link-->
              <!--router-link to="/titeres-recurso-didactico">Títeres como Recurso Didáctico</router-link-->
              <!--router-link to="/repaso-neuroanatomia">Un Repaso a la Neuroanatomía</router-link-->
              <!--router-link to="/explorando-sexualidad">Explorando mi Sexualidad</router-link-->
              <router-link to="/amor-codependencia">¿Amor o Codependencia?</router-link>
              <!--router-link to="/metas-proposito">Creando Metas con Propósito</router-link-->
              <router-link to="/heridas-nacimiento">Sanando Heridas de Nacimiento</router-link>
              <!--router-link to="/importancia-juego-infancias">La importancia del Juego en las Infancias</router-link-->
              <!--router-link to="/aprendiendo-amarme">Aprendiendo a Amarme</router-link-->
              <!--router-link to="/intervencion-dificultades-aprendizaje">Dificultades del Aprendizaje</router-link-->
              <!--router-link to="/aprendiendo-comunicarme">Aprendiendo a Comunicarnos</router-link-->
              <!--router-link to="/tecnicas-ludicas-adulto">Técnicas Lúdicas para el adulto mayor</router-link-->
              <!--router-link to="/importancia-ed-sexual-infancias">Importancia de la Educación Sexual en las Infancias</router-link-->
              <!--router-link to="/cuento-muerte">Cuento - Recurso didáctico para niños para abordar la muerte</router-link-->
              <!--router-link to="/estimulacion-lenguaje-03">La Estimulación del Lenguaje en Infantes de 0 a 3 años</router-link-->
              <!--router-link to="/sexualidad-placentera-etapa-adulta">Sexualidad Placentera en la Etapa Adulta</router-link-->
              <!--router-link to="/tecnicas-intervencion-tanatologicas">Técnicas de Intervención Tanatológicas</router-link-->
              <router-link to="/inmersion-sonora">Sesión de Inmersión Sonora</router-link>
              <!--router-link to="/cuento-recurso-socioemocional">El Cuento como Recurso Socioemocional</router-link-->
              <!--router-link to="/nuevo-proceso-civil-familiar">Nuevo Proceso Civil y Familiar</router-link-->
              <router-link to="/transformar-dolor-significado">Transformar el Dolor en Significado</router-link>
              <router-link to="/construyendo-anno-proposito">Construyendo el Año con Propósito</router-link>
              <router-link to="/renacer-despues-adversidad">Renacer Después de la Adversidad</router-link>
              <!--router-link to="/autoconocimiento">Autoconocimiento</router-link-->
              <!--router-link to="/elaboracion-demandas">Elaboración de Demandas</router-link-->
              <!--router-link to="/plenaria-posesion">Plenaria de Posesión o Publiciana</router-link-->
              <!--router-link to="/inteligencia-emocional">Inteligencia Emocional para la Vida</router-link-->
              <!-- <router-link
to="/mitos-del-amor-romantico"
>Mitos del amor romántico</router-link
> -->
            </nav>
          </div>
          <div class="col-md">
            <h3>Social media</h3>
            <nav class="nav flex-column menu-footer">
              <a href="https://www.facebook.com/profile.php?id=100063598561547" target="_blank"><i class="fab fa-facebook-square"></i>
                Facebook</a>
              <a href="https://x.com/IMPo_Oficial" target="_blank">
                <img src="https://www.centrodetanatologia.com/images/logo_x_a.webp" style="width:14px; margin:0; padding:0;"> x.com
              </a>
              <a href="https://www.instagram.com/impooficial/" target="_blank"><i class="fab fa-instagram"></i>
                Instagram</a>
              <a href="https://www.youtube.com/channel/UCCmxYMZSLn7QGoyo1qFPl9A" target="_blank"><i
                  class="fab fa-youtube-square"></i> YouTube</a>
              <a href="https://radioimpo.com.mx/" target="_blank"><i class="fa fa-microphone"></i> Radio IMPo</a>
            </nav>
          </div>
        </div>
      </div>
      <div class="pt-2 pb-2" style="background: #323747; color: #ccc">
        <div class="container">
          <div class="row">
            <div class="col-md text-center">2990397</div>
            <div class="col-md text-center">
              <a href="pdf/Aviso_de_Privacidad_CTTD.pdf" target="_blank">Aviso de privacidad</a>
            </div>
            <div class="col-md text-center">
              Potenciado por
              <a href="http://iesc.com.mx" target="_blank">IESC</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import JQuery from "jquery";
const $ = JQuery;
export default {
  mounted: function () {
    $(document).ready(function ($) {
      var listado = $(".ordenarm1");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });
      var listado = $(".ordenarm2");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });
      var listado = $(".ordenarmcursos");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });

      var listado = $(".ordenarf1");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });

      var listado = $(".ordenarf3");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });

      var listado = $(".ordenarf2");
      var elementos = listado.children("a").get();
      elementos.sort(function (a, b) {
        var A = $(a)
          .text()
          .toUpperCase();
        var B = $(b)
          .text()
          .toUpperCase();
        return A < B ? -1 : A > B ? 1 : 0;
      });
      $.each(elementos, function (id, elemento) {
        listado.append(elemento);
      });
    });
  },
  data() {
    return {
      json: [
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" },
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" },
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" },
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" },
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" },
        { id: 125, programa: 13, fecha: "22 de Febrero del 2019" }
      ]
    };
  },
  components: { carousel },
  name: "App"
};
</script>

<style>
body {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  line-height: 24px;
}

header {
  margin: 10px 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  color: #37407d;
  font-weight: 400;
}

h1 {
  font-size: 2.625rem;
}

h2 {
  font-size: 36px;
  line-height: 36px;
  margin: 0 0 20px 0;
  font-weight: 100;
}

h3 {
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  margin: 35px 0 10px 0;
}

h4 {
  margin-top: 35px;
  font-size: 1.25rem;
}

strong {
  color: #000;
}

.icon-50 {
  font-size: 50px;
  color: #37407d;
}

.container {
  max-width: 1200px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.logo {
  max-width: 150px;
}

.menu-area {
  background: #37407d;
  font-weight: 600;
  padding: 16px 0 0 0;
}

.navbar {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.nav a {
  color: #fff !important;
}

.nav-link {
  padding-bottom: 24px !important;
}

.nav a:hover {
  color: #7885db !important;
}

.nav a.router-link-exact-active {
  color: #7885db !important;
}

.nav a.router-link-exact-active:hover {
  color: rgb(133, 18, 18) !important;
}

.dropdown:hover>.dropdown-menu {
  display: block;
}

.dropdown-menu {
  font-size: 14px;
  margin-top: 0 !important;
  border-radius: 0;
  max-width: 450px !important;
  min-width: 350px;
}

.dropdown-menu a {
  color: #37407d !important;
  font-weight: 600;
}

.dropdown-menu a:hover {
  background: none;
  margin-left: 5px;
  transition: 500ms;
}

/*FOOTER*/
footer {
  margin-top: 10px;
  background: #131775;
  letter-spacing: 1.5px;
}

footer h3 {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
}

.menu-footer a,
footer p {
  color: #959595 !important;
}

.vineta a:before {
  content: "- ";
}

.menu-footer a:hover {
  /*text-decoration: none;*/
  color: #fff !important;
}

/*END FOOTER*/
/*WA logo*/
.wa-content {
  z-index: 9999;
  position: fixed;
  right: 90px;
  bottom: 25px;
}

.wa-content img {
  width: 60px;
}

.wa-content img:hover {
  cursor: pointer;
}

#modal-wa-dialog>.uk-modal-dialog {
  border-radius: 20px;
  position: fixed;
  right: 20px;
  bottom: 90px;
  max-width: 350px !important;
}

/* FIN WA logo */
</style>



// WEBPACK FOOTER //
// src/App.vue